<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <component-header
          title="Create Coupon"
          :hasSearch="false"
          :hasCreate="false"
          :hasReload="false"
          :hasback="true"
          @back-press="$router.push({ name: 'Coupon' })"
        />
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col md="12">
        <b-card>
          <ValidationObserver ref="observer" v-slot="{ invalid }">
            <form>
              <b-row>
                <b-col md="4">
                  <div class="form-group">
                    <label for="promoCode"
                      >Coupon Code
                      <i
                        id="button-1"
                        class="fas fa-question-circle"
                        style="color: #727cf5"
                      >
                        <b-tooltip
                          target="button-1"
                          placement="topright"
                          triggers="hover"
                          >Enter Coupon Code like COUPON2021,
                          NEWYEAROFFER.</b-tooltip
                        ></i
                      ></label
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Coupon Code"
                    >
                      <b-form-input
                        class="custom-transform-class"
                        id="promoCode"
                        @keydown="validateCode"
                        inputType="text"
                        v-model="inputObject.promoCode"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <label for="categoryOptions"
                      >Applicable On
                      <i
                        id="Applicable"
                        class="fas fa-question-circle"
                        style="color: #727cf5"
                      ></i
                      ><b-tooltip
                        target="Applicable"
                        placement="topright"
                        triggers="hover"
                        >Select “Order” from Applicable On</b-tooltip
                      >
                    </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Applicable On"
                    >
                      <eb-select
                        id="categoryOptions"
                        type="text"
                        label="label"
                        v-model="inputObject.applicableOn"
                        :options="categoryOptions"
                        @input="fetchAllPartnerList()"
                        placeholder="Select applicableOn"
                      ></eb-select>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col
                  md="4"
                  v-if="inputObject.applicableOn.value === 'CATALOG'"
                >
                  <div class="form-group">
                    <label for="catalog-id">Catalog</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Catalog"
                    >
                      <eb-select
                        id="catalog-id"
                        type="text"
                        label="text"
                        :options="catalogList"
                        v-model="inputObject.catalogId"
                        placeholder="Select Catalog"
                      ></eb-select>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col md="4" v-if="inputObject.applicableOn.value === 'ITEM'">
                  <b-row>
                    <b-col col="12">
                      <div class="form-group">
                        <label for="catalog-id">Catalog</label>
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="Catalog"
                        >
                          <eb-select
                            id="catalog-id"
                            type="text"
                            label="text"
                            :options="catalogList"
                            v-model="inputObject.catalogId"
                            placeholder="Select Item catalog"
                            @input="itemCatalogSelected"
                          ></eb-select>
                          <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row v-if="inputObject.catalogId && itemsList.length">
                    <b-col col="12">
                      <div class="form-group">
                        <label for="item-id">Item</label>
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="Item"
                        >
                          <eb-select
                            id="item-id"
                            type="text"
                            label="text"
                            :options="itemsList"
                            v-model="inputObject.itemId"
                            placeholder="Select Item"
                            @input="onchangeItem"
                            value="value"
                          ></eb-select>
                          <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                  md="4"
                  v-if="
                    inputObject.applicableOn.value === 'PARTNER' &&
                    userRole === 'Tenant'
                  "
                >
                  <div class="form-group">
                    <label for="selectSeller">Partner </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Partner"
                    >
                      <eb-select
                        type="text"
                        :id="'selectSeller'"
                        v-model="currentProvider"
                        :options="partnerList"
                        label="name"
                        placeholder="Select Partner"
                      ></eb-select>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <div class="form-group">
                    <label for="title"
                      >Title
                      <i
                        id="title"
                        class="fas fa-question-circle"
                        style="color: #727cf5"
                        ><b-tooltip
                          target="title"
                          placement="topright"
                          triggers="hover"
                          >Insert “Title” like COUPON2021,
                          NEWYEAROFFER.</b-tooltip
                        ></i
                      ></label
                    >
                    <br />
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Title"
                    >
                      <textarea
                        rows="4"
                        cols="30"
                        id="title"
                        class="form-control custom-transform-class"
                        inputType="text"
                        maxlength="300"
                        v-model="inputObject.title"
                      ></textarea>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <label for="description"
                      >Description
                      <i
                        id="Description"
                        class="fas fa-question-circle"
                        style="color: #727cf5"
                        ><b-tooltip
                          target="Description"
                          placement="topright"
                          triggers="hover"
                          >Get a reward of Rs.100 off on purchase of Rs.600 with
                          an attached this coupon.</b-tooltip
                        ></i
                      ></label
                    >
                    <br />
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="description"
                    >
                      <textarea
                        rows="4"
                        cols="30"
                        class="form-control"
                        id="description"
                        inputType="text"
                        maxlength="1500"
                        v-model="inputObject.description"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
              </b-row>
              <b-row> </b-row>
              <b-row>
                <b-col md="4">
                  <div class="form-group">
                    <label for="startdate"
                      >Start Date
                      <i
                        placement="topright"
                        id="startdate"
                        class="fas fa-question-circle"
                        style="color: #727cf5"
                        ><b-tooltip
                          target="startdate"
                          placement="topright"
                          triggers="hover"
                          >Select start date from calendar dropdown.</b-tooltip
                        ></i
                      ></label
                    >
                    <ValidationProvider
                      rules="required|futureDate"
                      v-slot="{ errors }"
                      name="Start Date"
                    >
                      <b-input
                        id="startdate"
                        type="date"
                        v-model="inputObject.startDate"
                      ></b-input>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <label for="enddate"
                      >End Date
                      <i
                        placement="topright"
                        id="enddate"
                        class="fas fa-question-circle"
                        style="color: #727cf5"
                        ><b-tooltip
                          target="enddate"
                          placement="topright"
                          triggers="hover"
                          >Select End date from calendar dropdown.</b-tooltip
                        ></i
                      ></label
                    >
                    <ValidationProvider
                      rules="required|afterDate:startDate"
                      v-slot="{ errors }"
                      name="End Date"
                    >
                      <b-input
                        id="enddate"
                        type="date"
                        v-model="inputObject.endDate"
                      ></b-input>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <label for="maxRewardValue"
                      >Max Reward Value
                      <i
                        placement="topright"
                        id="Max"
                        class="fas fa-question-circle"
                        style="color: #727cf5"
                        ><b-tooltip
                          target="Max"
                          placement="topright"
                          triggers="hover"
                          >Enter maximum reward value like 50,100.</b-tooltip
                        ></i
                      ></label
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Max Reward Value"
                    >
                      <b-form-input
                        id="maxRewardValue"
                        inputType="text"
                        maxlength="100"
                        v-model="inputObject.maxRewardValue"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <div class="form-group">
                    <label for="minimumAmountExcludingTax"
                      >Minimum Amount Excluding Tax
                      <i
                        placement="topright"
                        id="MinimumAmount"
                        class="fas fa-question-circle"
                        style="color: #727cf5"
                        ><b-tooltip
                          target="MinimumAmount"
                          placement="topright"
                          triggers="hover"
                          >Minimum value required to apply Coupon
                          Code.</b-tooltip
                        ></i
                      ></label
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Minimum Amount Excluding Tax"
                    >
                      <b-form-input
                        id="minimumAmountExcludingTax"
                        inputType="text"
                        maxlength="100"
                        v-model="inputObject.minimumAmountExcludingTax"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <label
                      for="rewardValue"
                      v-if="inputObject.discountType.value === 'Percentage'"
                      >Reward Percentage</label
                    >
                    <label for="rewardValue" v-else
                      >Reward Value
                      <i
                        placement="topright"
                        id="Reward"
                        class="fas fa-question-circle"
                        style="color: #727cf5"
                        ><b-tooltip
                          target="Reward"
                          placement="topright"
                          triggers="hover"
                          >Reward Value should be less or equal to Maximum
                          Reward Value.</b-tooltip
                        ></i
                      ></label
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Reward Value"
                    >
                      <b-input
                        id="rewardValue"
                        type="text"
                        v-model="inputObject.rewardValue"
                      ></b-input>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <label for="within"
                      >Frequency in minutes
                      <i
                        placement="topright"
                        id="Frequency"
                        class="fas fa-question-circle"
                        style="color: #727cf5"
                        ><b-tooltip
                          target="Frequency"
                          placement="topright"
                          triggers="hover"
                          >Number of times to apply coupon code per minute by
                          Customer like 5, 7 etc.</b-tooltip
                        ></i
                      ></label
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Timing Rules"
                    >
                      <b-form-input
                        id="within"
                        inputType="text"
                        v-model="timingRules.within"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
              </b-row>
              <div>
                <b-row>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="discountType"
                        >Discount Type
                        <i
                          placement="topright"
                          id="discountType"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                          ><b-tooltip
                            target="discountType"
                            placement="topright"
                            triggers="hover"
                            >Select “Number” from Discount Type
                            dropdown.</b-tooltip
                          ></i
                        ></label
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Discount Type"
                      >
                        <eb-select
                          id="discountType"
                          type="text"
                          label="label"
                          v-model="inputObject.discountType"
                          :options="discountType"
                          placeholder="Select discount type"
                        ></eb-select>
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="rewardType"
                        >Reward Type
                        <i
                          id="rewardType"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="rewardType"
                            placement="topright"
                            triggers="hover"
                            >Reward Type should be Discount.</b-tooltip
                          ></i
                        ></label
                      >
                      <eb-select
                        id="rewardType"
                        type="text"
                        label="label"
                        v-model="inputObject.rewardType"
                        :options="rewardType"
                        placeholder="Select reward type"
                      ></eb-select>
                    </div>
                  </b-col>
                  <b-col
                    md="4"
                    v-if="inputObject.rewardType.value === 'Wallet'"
                  >
                    <div class="form-group">
                      <label for="rewardBalanceType"
                        >Reward Balance Type
                        <i
                          id="rewardBalanceType"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="rewardBalanceType"
                            placement="topright"
                            triggers="hover"
                            >Reward Balance Type.</b-tooltip
                          ></i
                        ></label
                      >
                      <eb-select
                        id="rewardBalanceType"
                        type="text"
                        label="name"
                        v-model="inputObject.rewardBalanceType"
                        :options="rewardBalanceType"
                        placeholder="Select reward Balance type"
                      ></eb-select>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="inputObject.rewardType.value === 'Wallet'">
                  <b-col md="4">
                    <div class="form-group">
                      <label for="expiryValue"
                        >Enter Expiry
                        <i
                          id="expiryValue"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="expiryValue"
                            placement="topright"
                            triggers="hover"
                            >Time period for Expiry of the Coupon as
                            1,2,3.</b-tooltip
                          ></i
                        ></label
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Expiry"
                      >
                        <b-form-input
                          class="custom-transform-class"
                          id="expiryValue"
                          inputType="number"
                          placeholder="Enter Expiry Value"
                          v-model="inputObject.value"
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="uom"
                        >UOM
                        <i
                          id="uom"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                        >
                          <b-tooltip
                            target="uom"
                            placement="topright"
                            triggers="hover"
                            >Select Expiry Date UOM as Year, Months,
                            Days.</b-tooltip
                          ></i
                        ></label
                      >
                      <eb-select
                        type="text"
                        v-model="inputObject.uom"
                        :options="['Days', 'Months', 'Years']"
                        label="label"
                        id="uom"
                        class=""
                        placeholder="UOM"
                      ></eb-select>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="totalLimit"
                        >Total allowed in day
                        <i
                          placement="topright"
                          id="totalLimit"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                          ><b-tooltip
                            target="totalLimit"
                            placement="topright"
                            triggers="hover"
                            >Number of times coupon code can be used by customer
                            per day likes 5 or 10 times.</b-tooltip
                          ></i
                        ></label
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Timing Rules"
                      >
                        <b-form-input
                          id="totalLimit"
                          inputType="text"
                          v-model="timingRules.totalLimit"
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="maxExisting"
                        >Max Existing Orders
                        <i
                          placement="topright"
                          id="maxExisting"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                          ><b-tooltip
                            target="maxExisting"
                            placement="topright"
                            triggers="hover"
                            >Coupon will work only for people having existing
                            orders less than specified number</b-tooltip
                          ></i
                        ></label
                      >

                      <b-form-input
                        id="maxExisting"
                        inputType="text"
                        v-model="inputObject.maxExistingOrders"
                      />
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="minExiting"
                        >Min Existing Orders
                        <i
                          placement="topright"
                          id="minExiting"
                          class="fas fa-question-circle"
                          style="color: #727cf5"
                          ><b-tooltip
                            target="minExiting"
                            placement="topright"
                            triggers="hover"
                            >Coupon will be available only for those who have
                            this much existing orders.</b-tooltip
                          ></i
                        ></label
                      >
                      <b-form-input
                        id="minExiting"
                        inputType="text"
                        v-model="inputObject.minExistingOrders"
                      />
                    </div>
                  </b-col>
                  <b-col md="12">
                    <b-row>
                      <b-col md="4">
                        <div class="form-group">
                          <label for="maximumQuantity">Maximum Quantity </label>

                          <b-form-input
                            id="maximumQuantity"
                            inputType="text"
                            v-model="inputObject.maxQuantity"
                          />
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div class="form-group">
                          <label for="minimumQuantity">Minimum Quantity </label>

                          <b-form-input
                            id="minimumQuantity"
                            inputType="text"
                            v-model="inputObject.minQuantity"
                          />
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="12">
                    <b-row>
                      <b-col md="4">
                        <div class="form-group">
                          <b-form-checkbox switch v-model="showOption"
                            >Location Rule</b-form-checkbox
                          >
                        </div>
                      </b-col>
                      <b-col md="4" v-if="showOption === true">
                        <div class="form-group">
                          <label>Location</label>
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Location label"
                          >
                            <eb-select
                              id="locationSelect"
                              type="text"
                              label="text"
                              :options="['City', 'State']"
                              placeholder="Select Location Label"
                              v-model="inputObject.locationSelected"
                            ></eb-select>
                            <span class="validate-error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </b-col>
                      <b-col md="4" v-if="showOption === true">
                        <div class="form-group">
                          <label>Location Value</label>
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Location Value"
                          >
                            <b-form-input
                              inputType="text"
                              id="locationValue"
                              v-model="inputObject.locationValue"
                            >
                            </b-form-input>
                            <span class="validate-error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col md="4" v-for="(tc, idx) in tc" :key="idx">
                  <div class="form-group">
                    <label for="tc"
                      >Terms and Conditions
                      <i
                        placement="topright"
                        id="Terms"
                        class="fas fa-question-circle"
                        style="color: #727cf5"
                        ><b-tooltip
                          target="Terms"
                          placement="topright"
                          triggers="hover"
                          >Terms and Conditions like 1) This is valid on
                          purchase more than amount 200 2) This is valid for
                          valid period. 3) This is used only no of times per
                          day.</b-tooltip
                        ></i
                      ></label
                    >
                    <br />
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Terms and Conditions"
                    >
                      <textarea
                        id="tc"
                        rows="4"
                        cols="30"
                        class="form-control"
                        inputType="text"
                        maxlength="3000"
                        v-model="tc.tc"
                      ></textarea>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <div class="form-group">
                    <b-form-checkbox switch v-model="allowMultiDiscount"
                      >Allow MultiDiscount</b-form-checkbox
                    >
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <b-form-checkbox switch v-model="promote"
                      >Promote</b-form-checkbox
                    >
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <b-form-checkbox switch v-model="autoApply"
                      >AutoApply</b-form-checkbox
                    >
                  </div>
                </b-col>
              </b-row>
              <hr />
              <div class="text-center mt-3 mb-3">
                <button
                  type="button"
                  class="btn btn-primary  wide-button"
                  :disabled="invalid"
                   text="Save"
                  @click.prevent="handleSubmit"
                >
                  Save
                </button>
              </div>
            </form>
          </ValidationObserver>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
  Validator,
} from "vee-validate/dist/vee-validate.esm";
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import DatePicker from "vuejs-datepicker";
import moment from "moment";
import ebButton from "@/components/FormElements/Button";
import CouponDetails from "@/components/MasterSetup/Coupon/CouponDetails";
import { mapActions, mapGetters } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  name: "createfaq",
  components: {
    ebButton,
    cInput,
    DatePicker,
    ValidationProvider,
    ValidationObserver,
    ebSelect,
    CouponDetails,
    ComponentHeader,
  },
  data: () => {
    return {
      showOption: false,
      show: true,
      currentProvider: null,
      allowMultiDiscount: false,
      promote: false,
      autoApply: false,
      timingRules: [
        {
          within: "",
          totalLimit: "",
        },
      ],
      inputObject: {
        rewardType: "",
        rewardBalanceType: "",
        uom: "",
        value: 0,
        title: "",
        description: "",
        catalogId: "",
        maxRewardValue: "",
        minimumAmountExcludingTax: "",
        applicableOn: "",
        discountType: "",
        itemId: "",
        tags: [],
        startDate: "",
        endDate: "",
        promoCode: "",
        maxExistingOrders: null,
        minExistingOrders: null,
        minQuantity: null,
        maxQuantity: null,
        locationValue: "",
        locationSelected: "",
      },
      tc: [
        {
          tc: "",
          isRemovable: false,
          text: "Add",
        },
      ],
      catalogList: [
        {
          text: "Select Catalog",
          value: "1",
        },
      ],
      rewardType: [
        {
          label: "Discount",
          value: "Discount",
        },
        {
          label: "Shipping",
          value: "Shipping",
        },
        {
          label: "Wallet",
          value: "Wallet",
        },
      ],
      discountType: [
        {
          label: "Number",
          value: "Number",
        },
        {
          label: "Percentage",
          value: "Percentage",
        },
      ],
      itemsList: [],
    };
  },
  mounted() {
    this.Getpartnerlist({ type: "" });
    this.getCatalogName();
    this.GetWalletList();
    Validator.extend(
      "afterDate",
      (value, [otherValue]) => {
        return moment(value).diff(this.inputObject.startDate, "hour") >= 0;
      },
      {
        hasTarget: true,
      }
    );
    Validator.extend(
      "futureDate",
      (value, [otherValue]) => {
        return moment().diff(this.inputObject.startDate, "day") <= 0;
      },
      {
        hasTarget: true,
      }
    );
  },
  computed: {
    ...mapGetters({
      provider: "auth/getUserID",
    }),
    rewardBalanceType() {
      const data = this.$store.getters["partner/GetWalletData"];
      let rewardList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          let arrayObj = {
            _id: obj.resourceID,
            name: obj.code,
          };
          rewardList.push(arrayObj);
        });
        return rewardList;
      } else {
        return [];
      }
    },
    categoryOptions() {
      if (
        this.$currentUserData &&
        this.$currentUserData.category !== "SELLER"
      ) {
        return [
          {
            label: "Catalog",
            value: "CATALOG",
          },
          {
            label: "Partner",
            value: "PARTNER",
          },
          {
            label: "Item",
            value: "ITEM",
          },
          {
            label: "Order",
            value: "ORDER",
          },
          {
            label: "Registration",
            value: "REGISTRATION",
          },
          {
            label: "Referral",
            value: "REFERRAL",
          },
        ];
      } else {
        return [
          {
            label: "Catalog",
            value: "CATALOG",
          },
          {
            label: "Item",
            value: "ITEM",
          },
          {
            label: "Order",
            value: "ORDER",
          },
        ];
      }
    },
    partnerList() {
      let data = this.$store.getters["partner/GetPartnerLiteList"];
      let partnerList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          let arrayObj = {
            _id: obj._id,
            name: obj.organization.name,
            ...obj,
          };
          partnerList.push(arrayObj);
        });
        return partnerList;
      } else {
        return [];
      }
    },
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
  methods: {
    ...mapActions({
      Getpartnerlist: "partner/fetchPartnerListLite",
      GetWalletList: "partner/fetchWalletList",
    }),
    validateCode() {
      //
    },
    fetchAllPartnerList() {
      if (
        this.inputObject.applicableOn.value === "PARTNER" &&
        this.userRole === "Tenant"
      ) {
        if (Array.isArray(this.partnerList) && this.partnerList.length > 0) {
        } else {
          this.Getpartnerlist({ type: "" });
        }
      } else {
      }
    },
    async onClicktcButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.tc.push({
          tc: "",
          isRemovable: true,
          text: "Remove",
        });
      else this.tc.splice(idx, 1);
    },
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      let data = {
        promoCode: this.inputObject.promoCode.toUpperCase(),
        description: this.inputObject.description,
        title: this.inputObject.title.toUpperCase(),
        promoRules: {
          startDate: this.inputObject.startDate,
          endDate: this.inputObject.endDate,
          maxRewardValue: this.inputObject.maxRewardValue,
          minimumAmountExcludingTax: this.inputObject.minimumAmountExcludingTax,
          rewardValue: this.inputObject.rewardValue,
          discountType: this.inputObject.discountType.value,
          rewardType: this.inputObject.rewardType.value,
          applicableOn: this.inputObject.applicableOn.value,
          maxExistingOrders: this.inputObject.maxExistingOrders,
          minExistingOrders: this.inputObject.minExistingOrders,
          minQuantity: this.inputObject.minQuantity,
          maxQuantity: this.inputObject.maxQuantity,
        },
        timingRules: {
          within: this.timingRules.within,
          totalLimit: this.timingRules.totalLimit,
        },
        tc: this.tc.map((t) => t.tc),
        tags: this.inputObject.tags,
        autoApply: this.autoApply,
        allowMultiDiscount: this.allowMultiDiscount,
        promote: this.promote,
      };
      if (this.inputObject.rewardType.value === "Wallet") {
        data.promoRules.wallet = {
          amountType: {
            key: this.inputObject.rewardBalanceType._id,
            value: this.inputObject.rewardBalanceType.name,
          },
          expireIn: {
            value: +this.inputObject.value,
            uom: this.inputObject.uom,
          },
        };
      }
      if (this.inputObject.locationSelected.toLowerCase() === "city") {
        data.locationRules = {
          city: this.inputObject.locationValue.toLowerCase(),
        };
      } else if (this.inputObject.locationSelected.toLowerCase() === "state") {
        data.locationRules = {
          state: this.inputObject.locationValue.toLowerCase(),
        };
      }
      switch (this.inputObject.applicableOn.value) {
        case "ITEM":
          data.promoRules.itemId = this.inputObject.itemId.value;
          break;
        case "CATALOG":
          data.promoRules.catalogId = this.inputObject.catalogId.value;
          break;
        case "PARTNER":
          if (this.userRole === "Tenant") {
            data.promoRules.providerId = this.currentProvider
              ? this.currentProvider._id
              : null;
          }
      }
      await this.$store.dispatch("coupon/createCoupon", data).then(() => {
        this.$swal({
          title: "Success",
          text: "coupon added successfully!!",
          type: "success",
        });
      });
     await this.$store.dispatch(
  "coupon/couponCodeList",
  this.$store.getters["auth/getUserID"]
);

this.$router.push({ name: "Coupon" });

    },
    async getCatalogName() {
      if (this.userRole === "Tenant") {
        await this.$store.dispatch("catalog/fetchTenantCatalogTree");
        const result = await this.$store.getters[
          "catalog/GetTenantCatalogTree"
        ];
        this.catalogList = result
          .filter((Obj) => !Obj.isProductType && !Obj.isMarket)
          .map((c) => ({ text: c.name, value: c._id }));
        this.catalogList.reverse();
        this.isloader = false;
      } else {
        await this.$store.dispatch("catalog/fetchPartnerCatalogTree");
        const result = await this.$store.getters[
          "catalog/GetPartnerCatalogTree"
        ];
        this.catalogList = result
          .filter((Obj) => Obj.isProductType&& !Obj.isMarket)
          .map((c) => ({ text: c.name, value: c._id }));
        this.catalogList.reverse();
        this.isloader = false;
      }
    },
    async itemCatalogSelected(catalogId) {
      this.itemsList = [];
      let condition = {
        catalogId: catalogId.value,
      };
      if (this.userRole !== "Tenant") {
        condition.provider = this.$store.getters["auth/getUserID"];
      }
      const data = await this.$store.dispatch(
        "item/fetchItemsByCatalog",
        condition
      );
      const list = [];
      data.response.forEach((d) => {
        const name = d.string_attributes.find(
          (x) => x.attribute_name === "Name"
        );
        if (name) {
          list.push({
            text: name.attribute_value,
            value: d._id,
          });
        }
      });
      this.itemsList = list;
    },
  },
};
</script>
<style scoped>
.custom-transform-class {
  text-transform: uppercase;
}

.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}

.myDIV:hover + .hide {
  display: block;
  position: absolute;
}

.hide {
  display: none;
  font-size: 11px;
}
.wide-button {
  width: 100px; 
  height: 35px;
  font-size: 14px;
  text-align: center;
  justify-content: center;
  align-items: center;
}
</style>
